import { render, staticRenderFns } from "./PainelAnos.vue?vue&type=template&id=7fffdbf3&scoped=true"
import script from "./PainelAnos.vue?vue&type=script&lang=js"
export * from "./PainelAnos.vue?vue&type=script&lang=js"
import style0 from "./PainelAnos.vue?vue&type=style&index=0&id=7fffdbf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffdbf3",
  null
  
)

export default component.exports